import React, { useCallback } from 'react';

import { StyledSelect } from '../styled';

const t = {
  last_job: 'Last job was...',
};

const dateOptions = [
  { label: 'Last week', value: 'ONE_WEEK' },
  { label: 'Last month', value: 'ONE_MONTH' },
  { label: 'Last three months', value: 'THREE_MONTHS' },
  { label: 'Last six months', value: 'SIX_MONTHS' },
  { label: 'Any', value: 'ANY' },
];

const LastJobDateFilter = ({ value, handleChangeFilter }) => {
  const handleChangeDate = useCallback(
    (change) => {
      handleChangeFilter('date')((change && change.value) || '');
    },
    [handleChangeFilter]
  );

  return (
    <>
      <StyledSelect
        placeholder={t.last_job}
        ignoreCase={true}
        matchPos="any"
        name=""
        value={value}
        options={dateOptions}
        onChange={handleChangeDate}
        mandatory={false}
        small
        clearable
      />
    </>
  );
};

export default LastJobDateFilter;
